// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1puKx","loaderOuter":"PageOverlayLoader_loaderOuter__3K5l-"};